export const PrevUrl = "/api/v1"

export const TimeOut = 50000

export const validStatus = [200, 401, 500]

export const SuccessCode = 200